export default __webpack_public_path__ + "static/media/uniswapLogo.b1166848.png";